export default __webpack_public_path__ + "static/Rychla_volba-81ab6d6cefe3a8b43a7a059badd7fea3.svg";